// import SingleBarChartSimple from './charts/bar/SingleBarChartSimple.vue'
// import SingleBarChartBasic from './charts/bar/SingleBarChartBasic.vue'
// import SingleBarChartComplex from './charts/bar/SingleBarChartComplex.vue'
// import MultipleBarChartSimple from './charts/bar/MultipleBarChartSimple.vue'
// import MultipleBarChartBasic from './charts/bar/MultipleBarChartBasic.vue'
// import MultipleBarChartComplex from './charts/bar/MultipleBarChartComplex.vue'
// // Line Chart
// import SingleLineChartSimple from './charts/line/SingleLineChartSimple.vue'
// import SingleLineChartBasic from './charts/line/SingleLineChartBasic.vue'
// import SingleLineChartComplex from './charts/line/SingleLineChartComplex.vue'
// import MultipleLineChartSimple from './charts/line/MultipleLineChartSimple.vue'
// import MultipleLineChartBasic from './charts/line/MultipleLineChartBasic.vue'
// import MultipleLineChartComplex from './charts/line/MultipleLineChartComplex.vue'
// // Pie Chart
// import PieChartSimple from './charts/pie/PieChartSimple.vue'
// import PieChartSpacingSimple from './charts/pie/PieChartSpacingSimple.vue'
// import PieChartBasic from './charts/pie/PieChartBasic.vue'
// import PieChartSpacingBasic from './charts/pie/PieChartSpacingBasic.vue'
// // Doughnut Chart
// import DoughnutChartSimple from './charts/doughnut/DoughnutChartSimple.vue'
// import DoughnutChartBasic from './charts/doughnut/DoughnutChartBasic.vue'
// import SingleDoughnutChartSimple from './charts/doughnut/SingleDoughnutChartSimple.vue'
// import SingleDoughnutChartBasic from './charts/doughnut/SingleDoughnutChartBasic.vue'

// highchart
import LineChart from './charts/highchart/line/LineChart.vue'
import BarChart from './charts/highchart/bar/BarChart.vue'
import MPieChart from './charts/highchart/pie/MPieChart.vue'
import DonutChart from './charts/highchart/donut/DonutChart.vue'

import MTextHorizontal from './text/MTextHorizontal.vue'
import MTextVertical from './text/MTextVertical.vue'

import MFreezeTable from './table/MFreezeTable.vue'

const Components = {
	// SingleBarChartSimple,
	// SingleBarChartBasic,
	// SingleBarChartComplex,
	// MultipleBarChartSimple,
	// MultipleBarChartBasic,
	// MultipleBarChartComplex,
	// SingleLineChartSimple,
	// SingleLineChartBasic,
	// SingleLineChartComplex,
	// MultipleLineChartSimple,
	// MultipleLineChartBasic,
	// MultipleLineChartComplex,
	// PieChartSimple,
	// PieChartSpacingSimple,
	// PieChartBasic,
	// PieChartSpacingBasic,
	// DoughnutChartSimple,
	// DoughnutChartBasic,
	// SingleDoughnutChartSimple,
	// SingleDoughnutChartBasic,

	LineChart,
	BarChart,
	MPieChart,
	DonutChart,
	MTextHorizontal,
	MTextVertical,
	MFreezeTable
}

export default Components
